<template>

    <div id="destinationBackup" v-on:keyup.esc="close()"
        class="dialog draggable-item bg-light  light w-100-sm w-50 w-50-lg w-50-xl  h-75 ">

        <DialogTitle :title="destination.name ?? 'Configure Destination'"
            :defaultTitle="$t('Configure Destination')" :subTitle="$t('Destination') + ' ' + destination.type_name"
            @closeDialog="close()" />

        <div class="dialog-content overflow">

            <!--SCELTA DELLE CREDENZIALI-->
            <div v-if="destination.type != $ONEServiceType.FileFolder" class="form-group d-flex flex-column">
                <label class="text-bold">{{ $t("Choose credentials") }}</label>
                <input type="radio" :data-caption="$t('Create or select a repository')" @click="changeCredentialMode('repo')" data-role="radio" name="r1" :checked="credentialMode == 'repo'">
                <input type="radio" :data-caption="$t('Create or select a service account')" @click="changeCredentialMode('sa')" data-role="radio" name="r1" :checked="credentialMode == 'sa'">
            </div>

            <!------------------------------SCELTA DEL REPOSITORY--------------------------------------------------------------->
            <div v-if="destination.type != $ONEServiceType.FileFolder && credentialMode == 'repo'">
                <SARepoSelect 
                    :type=destination.type :idRepo="destination.id_repository" :idSA=destination.id_service_account :selectRepo="true" 
                    @sendSATestResult="sendSATestResult" key="selectRepo"
                />
            </div>
            

            <!------------------------------SCELTA DEL SERVICE ACCOUNT--------------------------------------------------------------->
            <!--Questa pagina deve implementare il metodo "sendSATestResult"-->
            <div v-else-if="destination.type != $ONEServiceType.FileFolder && credentialMode == 'sa'">
                <SARepoSelect 
                    :type=destination.type :idSA=destination.id_service_account :selectRepo="false" :idRepo="-2"
                    @sendSATestResult="sendSATestResult" key="selectSA"/>
            </div>
            

            <!--SCELTA DEL PERCORSO-->
            <SelectedResourcesLayout buttonText="Select destination folder" :singleItem="true"
                :isDisabled="destination.type != $ONEServiceType.FileFolder && !testResult.ok"
                :folderSelectionDisabled="isObjectLockServiceAccount"
                :list="selectedNodes" :heightPercentage="0" :canCancel="true" :type="destination.type"
                @clickFunction="toggleFileSystemSidebar" @setNewPath="setPathAndName"
                v-if="credentialMode != 'repo'"
                />
            <div v-if="isObjectLockServiceAccount && credentialMode != 'repo'" class="form-group fg-cobalt text-small">
                <p class="mb-1">{{ $t("This service account is configured for Object Lock / immutability. Enter the bucket path manually; if the bucket does not exist, it will be created with Object Lock enabled so backups can be protected from deletion for the configured retention period.") }}</p>
                <p class="mb-0">{{ $t("Use forward slashes (/) as path separators. Do not use backslashes (\\).") }}</p>
            </div>

            <!--SCELTA DEL NOME-->
            <div class="form-group" :disabled="destination.type == $ONEServiceType.FileFolder && destination.path == ''">
                <label class="text-bold">{{ $t("Backup Destination name") }}</label>
                <input class="input" data-role="input" v-model.trim="destination.name" />
            </div>
        </div>
        <!--BOTTONI-->
        <div class="dialog-actions">
                <div v-if="saveButton_disabled_message != ''" class="mr-auto w-50 p-0 fg-cobalt" :title="saveButton_disabled_message"><pre class="text-small text-truncate">{{ saveButton_disabled_message }}</pre></div>

                <button class="button secondary" :disabled="!enableSave" @click="save" v-disable-tooltip:saveButton_disabled_message> {{ $t("Save") }}</button>
                <button class="button secondary" @click="close()"> {{ $t("Close") }}</button>
        </div>
    </div>
</template>

<script>
import DialogTitle from "../../utils/DialogTitle";
import SelectedResourcesLayout from "../../utils/SelectedResourcesLayout";
import SARepoSelect from "../../utils/SARepoSelect.vue";
import { getNodeType, isValid } from "../../../utils/utilitiesmodule";
import { FileSystemSidebarConfig } from "../../../models/TreeNode";
import { draggableMixin } from "../../../mixins/draggable-mixin";
import { disconnectServiceAccount, getSARootPath } from "../../../utils/entityMethods/serviceAccount";

export default {
    name: "Destination",
    mixins: [draggableMixin],
    props: {
        destination: Object
    },
    components: {
        "DialogTitle": DialogTitle,
        SARepoSelect,
        SelectedResourcesLayout
    },

    data() {
        return {
            paths: [],
            credentialMode: '',
            selectedNodes: [],
            testResult: {
                ok: false,
                okNumber: 0,
                serviceAccount: { id: -2, type: this.destination.type },
                client: null,// il client della piattaforma che effettuerà le richieste dei list
                list: null,
            },
            saveButton_disabled_message: ""
        }
    },
    computed: {
        enableSave() {

            if (this.destination.name=="") {
                this.saveButton_disabled_message=this.$t("Insert a name");
                return false;
            }

            if (this.destination.type==this.$ONEServiceType.FileFolder) {
                if (this.destination.path!='') {
                    return true;
                }
                this.saveButton_disabled_message=this.$t("Select a path");
                return false;
            }



            if (!this.testResult.ok) {
                this.saveButton_disabled_message=this.$t("Select and validate a service account");
                return false;
            }

            if (this.credentialMode=='repo') {
                this.saveButton_disabled_message="";
                return true;
            }

            if (this.isObjectLockServiceAccount && this.destination.path.includes("\\")) {
                this.saveButton_disabled_message=this.$t("Use forward slashes (/) as path separators. Do not use backslashes (\\).");
                return false;
            }

            if (
                [this.$ONEServiceType.Network, this.$ONEServiceType.FTP].includes(this.destination.type)&&
                this.destination.path==""
            ) {
                this.saveButton_disabled_message=this.$t("Select a path");
                return false
            }
            this.saveButton_disabled_message="";
            return true;
            /*var partialValue=(this.destination.type==this.$ONEServiceType.FileFolder&&this.destination.path!="")||
                (this.destination.type!=this.$ONEServiceType.FileFolder&&this.credentialMode=="repo"&&this.destination.path!="")||
                (this.destination.type!=this.$ONEServiceType.FileFolder&&this.credentialMode=="sa"&&this.selectedNodes.length==1)
            return this.destination.name!=""&&partialValue;*/
        },
        isObjectLockServiceAccount() {
            const options = this.testResult.serviceAccount?.options;
            return options != null && (options.objLock_enabled == 1 || options.objLock_enabled == 1);
        }
    },
    watch: {
        selectedNodes: {
            handler: function(value) {
                if (this.credentialMode=='repo'||value.length==0) {
                    return;
                }

                this.setPathAndName(value[0].path);
            }
        }
    },

    created() {

        if (this.destination.type==this.$ONEServiceType.FileFolder) {
            this.credentialMode="";
            this.destination.id_service_account=-2;
            this.destination.id_repository=-2;
            this.selectedNodes.push({
                path: this.destination.path,
                type: getNodeType(this.destination.type, false)
            });
            return;
        }

        if (this.destination.id==null||this.destination.id_repository!=-2) {
            this.credentialMode="repo";
            this.destination.id_service_account=-2;
            return;
        }

        this.credentialMode="sa";
        this.selectedNodes.push({
            path: this.destination.path,
            type: getNodeType(this.destination.type, false)
        });
        this.destination.id_repository=-2;
    },

    async beforeDestroy() {
        this.$root.$emit("closeFileSystemSidebar");

        this.$root.$off("socketEventConnected");
        this.$root.$off("socketEventDisconnected");
        if (this.testResult.client!=null) {
            this.disconnectServiceAccount(this.testResult.client.serviceAccount);
        }
    },
    methods: {
        disconnectServiceAccount,
        getSARootPath,

        sendSATestResult(testResult) {
            this.testResult=testResult;
            if (isValid(testResult.repository)) {
                this.destination.name=testResult.repository.name;
                this.destination.id_repository=testResult.repository.id;
                this.destination.id_service_account=-2;
                this.destination.path="";
                //this.selectedNodes[0].path = this.destination.path;
                return;
            }

            this.destination.id_service_account=testResult.serviceAccount.id;
            this.destination.id_repository=-2;
            var rootPath=this.getSARootPath(testResult.serviceAccount);
            if (this.destination.path=="") {
                this.selectedNodes.splice(0, 1);
                this.selectedNodes.push({
                    path: rootPath,
                    type: getNodeType(this.destination.type, false)
                });
                //this.setPathAndName(rootPath);
            }

        },

        setPathAndName(path) {
            var config={
                path: path,
                type: this.destination.type
            };

            if ([this.$ONEServiceType.Network, this.$ONEServiceType.FTP].includes(this.destination.type)) {
                config.prefix=this.getSARootPath(this.testResult.serviceAccount);
            }

            if (this.destination.type!=this.$ONEServiceType.FileFolder) {
                config.saName=this.testResult.serviceAccount.name;
            }

            if (this.destination.id_repository!=-2) {
                config.repoName=this.testResult.repository.name;
            }

            [this.destination.path, this.destination.name]=this.$root.getPathAndName(config);
            // if (this.selectedNodes.length!=0) {
            //     this.selectedNodes.splice(0, 1);

            // }
            // this.selectedNodes.push({
            //     path: this.destination.path,
            //     type: getNodeType(this.destination.type, false)
            // });

            /*if (this.credentialMode=='sa') {
                this.selectedNodes.splice(0, 1);
                this.selectedNodes.push({
                    path: this.destination.path,
                    type: getNodeType(this.destination.type, false)
                });
            }*/

        },

        changeCredentialMode(value) {
            this.credentialMode=value;
            if (value=="sa") {
                this.destination.id_repository=-2;
                this.destination.id_service_account="";
            } else {
                this.destination.id_service_account=-2;
                this.destination.id_repository="";
                this.destination.path="";
            }
        },
        async toggleFileSystemSidebar() {
            if (this.isObjectLockServiceAccount) {
                return;
            }

            var config=FileSystemSidebarConfig.getForDestination(
                this.destination.type,
                this.testResult.client,
                this.getSARootPath(this.testResult.serviceAccount),
                [this.$ONEServiceType.Network, this.$ONEServiceType.FTP].includes(this.destination.type)
            );

            this.$root.$emit("toggleFileSystemSidebar", this.selectedNodes, config);
        },

        async save() {
            this.$root.$emit("closeFileSystemSidebar");

            if (this.credentialMode=='repo') {
                this.$root.$emit("saveBackupDestination", this.destination);
                return;
            }

            if (this.selectedNodes.length==1&&this.selectedNodes[0].path!="") {
                this.destination.path=this.selectedNodes[0].path;
            }

            if (this.destination.type==this.$ONEServiceType.FTP&&!this.destination.path.startsWith(this.testResult.client.serviceAccount.url)) {
                this.destination.path=this.testResult.client.serviceAccount.url+"/"+this.destination.path;
            }

            //salva la destinazione nel job e chiude la dialog
            this.$root.$emit("saveBackupDestination", this.destination);
        },

        cancel() {
            this.$root.$emit("uncheckNode", this.selectedNodes.pop());
        },

        async close() {
            this.$root.$emit('CLOSEDESTINATIONDIALOG');
        },
    }
}
</script>
